// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ProfileEmptyState-cls1___09f3bc76959095f6b87{/*!*/}.ProfileEmptyState-cls2___621f54bf06c1f066816{font-family:\"Roboto\",Helvetica,Arial,sans-serif;font-size:22px;font-weight:400;line-height:28px;color:#223}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "ProfileEmptyState-cls1___09f3bc76959095f6b87",
	"cls2": "ProfileEmptyState-cls2___621f54bf06c1f066816 ProfileEmptyState-cls1___09f3bc76959095f6b87"
};
export default ___CSS_LOADER_EXPORT___;
